import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { decode as msgpackDecode } from '@msgpack/msgpack';
import registerEn from '../locales/en/register.json';
import registerDe from '../locales/de/register.json';
import registerEs from '../locales/es/register.json';
import registerFi from '../locales/fi/register.json';
import registerFr from '../locales/fr/register.json';
import registerTr from '../locales/tr/register.json';
import downloadsEn from '../locales/en/downloads.json';
import downloadsDe from '../locales/de/downloads.json';
import downloadsEs from '../locales/es/downloads.json';
import downloadsFr from '../locales/fr/downloads.json';
import downloadsFi from '../locales/fi/downloads.json';
import downloadsTr from '../locales/tr/downloads.json';
import sidebarEn from '../locales/en/sidebar.json';
import sidebarDe from '../locales/de/sidebar.json';
import sidebarEs from '../locales/es/sidebar.json';
import sidebarFr from '../locales/fr/sidebar.json';
import sidebarFi from '../locales/fi/sidebar.json';
import sidebarTr from '../locales/tr/sidebar.json';
import onboardingEn from '../locales/en/onboarding.json';
import onboardingDe from '../locales/de/onboarding.json';
import onboardingEs from '../locales/es/onboarding.json';
import onboardingFr from '../locales/fr/onboarding.json';
import onboardingFi from '../locales/fi/onboarding.json';
import onboardingTr from '../locales/tr/onboarding.json';
import invitationsEn from '../locales/en/invitations.json';
import invitationsDe from '../locales/de/invitations.json';
import invitationsEs from '../locales/es/invitations.json';
import invitationsFi from '../locales/fi/invitations.json';
import invitationsFr from '../locales/fr/invitations.json';
import invitationsTr from '../locales/tr/invitations.json';
import usagesEn from '../locales/en/usages.json';
import usagesDe from '../locales/de/usages.json';
import usagesEs from '../locales/es/usages.json';
import usagesFi from '../locales/fi/usages.json';
import usagesFr from '../locales/fr/usages.json';
import usagesTr from '../locales/tr/usages.json';
import licensesEn from '../locales/en/licenses.json';
import licensesDe from '../locales/de/licenses.json';
import licensesEs from '../locales/es/licenses.json';
import licensesFi from '../locales/fi/licenses.json';
import licensesFr from '../locales/fr/licenses.json';
import licensesTr from '../locales/tr/licenses.json';
import acceptInviteEn from '../locales/en/acceptInvite.json';
import acceptInviteDe from '../locales/de/acceptInvite.json';
import acceptInviteEs from '../locales/es/acceptInvite.json';
import acceptInviteFi from '../locales/fi/acceptInvite.json';
import acceptInviteFr from '../locales/fr/acceptInvite.json';
import acceptInviteTr from '../locales/tr/acceptInvite.json';
import platformDefaultsEn from '../locales/en/platformDefaults.json';
import platformDefaultsDe from '../locales/de/platformDefaults.json';
import platformDefaultsEs from '../locales/es/platformDefaults.json';
import platformDefaultsFi from '../locales/fi/platformDefaults.json';
import platformDefaultsFr from '../locales/fr/platformDefaults.json';
import platformDefaultsTr from '../locales/tr/platformDefaults.json';
import assetsEn from '../locales/en/assets.json';
import assetsDe from '../locales/de/assets.json';
import assetsEs from '../locales/es/assets.json';
import assetsFr from '../locales/fr/assets.json';
import assetsFi from '../locales/fi/assets.json';
import assetsTr from '../locales/tr/assets.json';
import foldersEn from '../locales/en/folders.json';
import foldersDe from '../locales/de/folders.json';
import foldersEs from '../locales/es/folders.json';
import foldersFr from '../locales/fr/folders.json';
import foldersFi from '../locales/fi/folders.json';
import foldersTr from '../locales/tr/folders.json';
import usersEn from '../locales/en/users.json';
import usersDe from '../locales/de/users.json';
import usersEs from '../locales/es/users.json';
import usersFr from '../locales/fr/users.json';
import usersFi from '../locales/fi/users.json';
import usersTr from '../locales/tr/users.json';
import devicesEn from '../locales/en/devices.json';
import devicesDe from '../locales/de/devices.json';
import devicesEs from '../locales/es/devices.json';
import devicesFr from '../locales/fr/devices.json';
import devicesFi from '../locales/fi/devices.json';
import devicesTr from '../locales/tr/devices.json';
import adminPasswordsEn from '../locales/en/adminPasswords.json';
import adminPasswordsDe from '../locales/de/adminPasswords.json';
import adminPasswordsEs from '../locales/es/adminPasswords.json';
import adminPasswordsFr from '../locales/fr/adminPasswords.json';
import adminPasswordsFi from '../locales/fi/adminPasswords.json';
import adminPasswordsTr from '../locales/tr/adminPasswords.json';
import adminPolicyEn from '../locales/en/adminPolicy.json';
import adminPolicyDe from '../locales/de/adminPolicy.json';
import adminPolicyEs from '../locales/es/adminPolicy.json';
import adminPolicyFr from '../locales/fr/adminPolicy.json';
import adminPolicyFi from '../locales/fi/adminPolicy.json';
import adminPolicyTr from '../locales/tr/adminPolicy.json';
import adminNotificationsEn from '../locales/en/adminNotifications.json';
import adminNotificationsDe from '../locales/de/adminNotifications.json';
import adminNotificationsEs from '../locales/es/adminNotifications.json';
import adminNotificationsFr from '../locales/fr/adminNotifications.json';
import adminNotificationsFi from '../locales/fi/adminNotifications.json';
import adminNotificationsTr from '../locales/tr/adminNotifications.json';
import adminWatermarksEn from '../locales/en/adminWatermarks.json';
import adminWatermarksDe from '../locales/de/adminWatermarks.json';
import adminWatermarksEs from '../locales/es/adminWatermarks.json';
import adminWatermarksFr from '../locales/fr/adminWatermarks.json';
import adminWatermarksFi from '../locales/fi/adminWatermarks.json';
import adminWatermarksTr from '../locales/tr/adminWatermarks.json';
import companiesEn from '../locales/en/companies.json';
import companiesDe from '../locales/de/companies.json';
import companiesEs from '../locales/es/companies.json';
import companiesFr from '../locales/fr/companies.json';
import companiesFi from '../locales/fi/companies.json';
import companiesTr from '../locales/tr/companies.json';
import userDetailsEn from '../locales/en/userDetails.json';
import userDetailsDe from '../locales/de/userDetails.json';
import userDetailsEs from '../locales/es/userDetails.json';
import userDetailsFr from '../locales/fr/userDetails.json';
import userDetailsFi from '../locales/fi/userDetails.json';
import userDetailsTr from '../locales/tr/userDetails.json';
import assetEditEn from '../locales/en/assetEdit.json';
import assetEditDe from '../locales/de/assetEdit.json';
import assetEditEs from '../locales/es/assetEdit.json';
import assetEditFr from '../locales/fr/assetEdit.json';
import assetEditFi from '../locales/fi/assetEdit.json';
import assetEditTr from '../locales/tr/assetEdit.json';
import adminAssetProtectionEn from '../locales/en/adminAssetProtection.json';
import adminAssetProtectionDe from '../locales/de/adminAssetProtection.json';
import adminAssetProtectionEs from '../locales/es/adminAssetProtection.json';
import adminAssetProtectionFr from '../locales/fr/adminAssetProtection.json';
import adminAssetProtectionFi from '../locales/fi/adminAssetProtection.json';
import adminAssetProtectionTr from '../locales/tr/adminAssetProtection.json';
import profileEn from '../locales/en/profile.json';
import profileDe from '../locales/de/profile.json';
import profileEs from '../locales/es/profile.json';
import profileFr from '../locales/fr/profile.json';
import profileFi from '../locales/fi/profile.json';
import profileTr from '../locales/tr/profile.json';
import settingsEn from '../locales/en/settings.json';
import settingsDe from '../locales/de/settings.json';
import settingsEs from '../locales/es/settings.json';
import settingsFr from '../locales/fr/settings.json';
import settingsFi from '../locales/fi/settings.json';
import settingsTr from '../locales/tr/settings.json';
import subscriptionsEn from '../locales/en/subscriptions.json';
import subscriptionsDe from '../locales/de/subscriptions.json';
import subscriptionsEs from '../locales/es/subscriptions.json';
import subscriptionsFi from '../locales/fi/subscriptions.json';
import subscriptionsFr from '../locales/fr/subscriptions.json';
import subscriptionsTr from '../locales/tr/subscriptions.json';
import inviteDetailsEn from '../locales/en/inviteDetails.json';
import inviteDetailsDe from '../locales/de/inviteDetails.json';
import inviteDetailsEs from '../locales/es/inviteDetails.json';
import inviteDetailsFi from '../locales/fi/inviteDetails.json';
import inviteDetailsFr from '../locales/fr/inviteDetails.json';
import inviteDetailsTr from '../locales/tr/inviteDetails.json';
import clientFormEn from '../locales/en/clientForm.json';
import clientFormDe from '../locales/de/clientForm.json';
import clientFormEs from '../locales/es/clientForm.json';
import clientFormFr from '../locales/fr/clientForm.json';
import clientFormFi from '../locales/fi/clientForm.json';
import clientFormTr from '../locales/tr/clientForm.json';

const onboardingFallbacks: Record<string, Record<string, unknown>> = {
  en: onboardingEn as Record<string, unknown>,
  de: onboardingDe as Record<string, unknown>,
  es: onboardingEs as Record<string, unknown>,
  fr: onboardingFr as Record<string, unknown>,
  fi: onboardingFi as Record<string, unknown>,
  tr: onboardingTr as Record<string, unknown>,
};

const sidebarFallbacks: Record<string, Record<string, unknown>> = {
  en: sidebarEn as Record<string, unknown>,
  de: sidebarDe as Record<string, unknown>,
  es: sidebarEs as Record<string, unknown>,
  fr: sidebarFr as Record<string, unknown>,
  fi: sidebarFi as Record<string, unknown>,
  tr: sidebarTr as Record<string, unknown>,
};

const downloadsFallbacks: Record<string, Record<string, unknown>> = {
  en: downloadsEn as Record<string, unknown>,
  de: downloadsDe as Record<string, unknown>,
  es: downloadsEs as Record<string, unknown>,
  fr: downloadsFr as Record<string, unknown>,
  fi: downloadsFi as Record<string, unknown>,
  tr: downloadsTr as Record<string, unknown>,
};

const registerFallbacks: Record<string, Record<string, unknown>> = {
  en: registerEn as Record<string, unknown>,
  de: registerDe as Record<string, unknown>,
  es: registerEs as Record<string, unknown>,
  fi: registerFi as Record<string, unknown>,
  fr: registerFr as Record<string, unknown>,
  tr: registerTr as Record<string, unknown>,
};

const invitationsFallbacks: Record<string, Record<string, unknown>> = {
  en: invitationsEn as Record<string, unknown>,
  de: invitationsDe as Record<string, unknown>,
  es: invitationsEs as Record<string, unknown>,
  fr: invitationsFr as Record<string, unknown>,
  fi: invitationsFi as Record<string, unknown>,
  tr: invitationsTr as Record<string, unknown>,
};

const usagesFallbacks: Record<string, Record<string, unknown>> = {
  en: usagesEn as Record<string, unknown>,
  de: usagesDe as Record<string, unknown>,
  es: usagesEs as Record<string, unknown>,
  fr: usagesFr as Record<string, unknown>,
  fi: usagesFi as Record<string, unknown>,
  tr: usagesTr as Record<string, unknown>,
};

const licensesFallbacks: Record<string, Record<string, unknown>> = {
  en: licensesEn as Record<string, unknown>,
  de: licensesDe as Record<string, unknown>,
  es: licensesEs as Record<string, unknown>,
  fr: licensesFr as Record<string, unknown>,
  fi: licensesFi as Record<string, unknown>,
  tr: licensesTr as Record<string, unknown>,
};

const acceptInviteFallbacks: Record<string, Record<string, unknown>> = {
  en: acceptInviteEn as Record<string, unknown>,
  de: acceptInviteDe as Record<string, unknown>,
  es: acceptInviteEs as Record<string, unknown>,
  fr: acceptInviteFr as Record<string, unknown>,
  fi: acceptInviteFi as Record<string, unknown>,
  tr: acceptInviteTr as Record<string, unknown>,
};

const platformDefaultsFallbacks: Record<string, Record<string, unknown>> = {
  en: platformDefaultsEn as Record<string, unknown>,
  de: platformDefaultsDe as Record<string, unknown>,
  es: platformDefaultsEs as Record<string, unknown>,
  fr: platformDefaultsFr as Record<string, unknown>,
  fi: platformDefaultsFi as Record<string, unknown>,
  tr: platformDefaultsTr as Record<string, unknown>,
};

const assetsFallbacks: Record<string, Record<string, unknown>> = {
  en: assetsEn as Record<string, unknown>,
  de: assetsDe as Record<string, unknown>,
  es: assetsEs as Record<string, unknown>,
  fr: assetsFr as Record<string, unknown>,
  fi: assetsFi as Record<string, unknown>,
  tr: assetsTr as Record<string, unknown>,
};

const foldersFallbacks: Record<string, Record<string, unknown>> = {
  en: foldersEn as Record<string, unknown>,
  de: foldersDe as Record<string, unknown>,
  es: foldersEs as Record<string, unknown>,
  fr: foldersFr as Record<string, unknown>,
  fi: foldersFi as Record<string, unknown>,
  tr: foldersTr as Record<string, unknown>,
};

const usersFallbacks: Record<string, Record<string, unknown>> = {
  en: usersEn as Record<string, unknown>,
  de: usersDe as Record<string, unknown>,
  es: usersEs as Record<string, unknown>,
  fr: usersFr as Record<string, unknown>,
  fi: usersFi as Record<string, unknown>,
  tr: usersTr as Record<string, unknown>,
};

const devicesFallbacks: Record<string, Record<string, unknown>> = {
  en: devicesEn as Record<string, unknown>,
  de: devicesDe as Record<string, unknown>,
  es: devicesEs as Record<string, unknown>,
  fr: devicesFr as Record<string, unknown>,
  fi: devicesFi as Record<string, unknown>,
  tr: devicesTr as Record<string, unknown>,
};

const adminPasswordsFallbacks: Record<string, Record<string, unknown>> = {
  en: adminPasswordsEn as Record<string, unknown>,
  de: adminPasswordsDe as Record<string, unknown>,
  es: adminPasswordsEs as Record<string, unknown>,
  fr: adminPasswordsFr as Record<string, unknown>,
  fi: adminPasswordsFi as Record<string, unknown>,
  tr: adminPasswordsTr as Record<string, unknown>,
};

const adminPolicyFallbacks: Record<string, Record<string, unknown>> = {
  en: adminPolicyEn as Record<string, unknown>,
  de: adminPolicyDe as Record<string, unknown>,
  es: adminPolicyEs as Record<string, unknown>,
  fr: adminPolicyFr as Record<string, unknown>,
  fi: adminPolicyFi as Record<string, unknown>,
  tr: adminPolicyTr as Record<string, unknown>,
};

const adminNotificationsFallbacks: Record<string, Record<string, unknown>> = {
  en: adminNotificationsEn as Record<string, unknown>,
  de: adminNotificationsDe as Record<string, unknown>,
  es: adminNotificationsEs as Record<string, unknown>,
  fr: adminNotificationsFr as Record<string, unknown>,
  fi: adminNotificationsFi as Record<string, unknown>,
  tr: adminNotificationsTr as Record<string, unknown>,
};

const adminWatermarksFallbacks: Record<string, Record<string, unknown>> = {
  en: adminWatermarksEn as Record<string, unknown>,
  de: adminWatermarksDe as Record<string, unknown>,
  es: adminWatermarksEs as Record<string, unknown>,
  fr: adminWatermarksFr as Record<string, unknown>,
  fi: adminWatermarksFi as Record<string, unknown>,
  tr: adminWatermarksTr as Record<string, unknown>,
};

const companiesFallbacks: Record<string, Record<string, unknown>> = {
  en: companiesEn as Record<string, unknown>,
  de: companiesDe as Record<string, unknown>,
  es: companiesEs as Record<string, unknown>,
  fr: companiesFr as Record<string, unknown>,
  fi: companiesFi as Record<string, unknown>,
  tr: companiesTr as Record<string, unknown>,
};

const userDetailsFallbacks: Record<string, Record<string, unknown>> = {
  en: userDetailsEn as Record<string, unknown>,
  de: userDetailsDe as Record<string, unknown>,
  es: userDetailsEs as Record<string, unknown>,
  fr: userDetailsFr as Record<string, unknown>,
  fi: userDetailsFi as Record<string, unknown>,
  tr: userDetailsTr as Record<string, unknown>,
};

const assetEditFallbacks: Record<string, Record<string, unknown>> = {
  en: assetEditEn as Record<string, unknown>,
  de: assetEditDe as Record<string, unknown>,
  es: assetEditEs as Record<string, unknown>,
  fr: assetEditFr as Record<string, unknown>,
  fi: assetEditFi as Record<string, unknown>,
  tr: assetEditTr as Record<string, unknown>,
};

const adminAssetProtectionFallbacks: Record<string, Record<string, unknown>> = {
  en: adminAssetProtectionEn as Record<string, unknown>,
  de: adminAssetProtectionDe as Record<string, unknown>,
  es: adminAssetProtectionEs as Record<string, unknown>,
  fr: adminAssetProtectionFr as Record<string, unknown>,
  fi: adminAssetProtectionFi as Record<string, unknown>,
  tr: adminAssetProtectionTr as Record<string, unknown>,
};

const profileFallbacks: Record<string, Record<string, unknown>> = {
  en: profileEn as Record<string, unknown>,
  de: profileDe as Record<string, unknown>,
  es: profileEs as Record<string, unknown>,
  fr: profileFr as Record<string, unknown>,
  fi: profileFi as Record<string, unknown>,
  tr: profileTr as Record<string, unknown>,
};

const settingsFallbacks: Record<string, Record<string, unknown>> = {
  en: settingsEn as Record<string, unknown>,
  de: settingsDe as Record<string, unknown>,
  es: settingsEs as Record<string, unknown>,
  fr: settingsFr as Record<string, unknown>,
  fi: settingsFi as Record<string, unknown>,
  tr: settingsTr as Record<string, unknown>,
};

const subscriptionsFallbacks: Record<string, Record<string, unknown>> = {
  en: subscriptionsEn as Record<string, unknown>,
  de: subscriptionsDe as Record<string, unknown>,
  es: subscriptionsEs as Record<string, unknown>,
  fr: subscriptionsFr as Record<string, unknown>,
  fi: subscriptionsFi as Record<string, unknown>,
  tr: subscriptionsTr as Record<string, unknown>,
};

const inviteDetailsFallbacks: Record<string, Record<string, unknown>> = {
  en: inviteDetailsEn as Record<string, unknown>,
  de: inviteDetailsDe as Record<string, unknown>,
  es: inviteDetailsEs as Record<string, unknown>,
  fi: inviteDetailsFi as Record<string, unknown>,
  fr: inviteDetailsFr as Record<string, unknown>,
  tr: inviteDetailsTr as Record<string, unknown>,
};

const clientFormFallbacks: Record<string, Record<string, unknown>> = {
  en: clientFormEn as Record<string, unknown>,
  de: clientFormDe as Record<string, unknown>,
  es: clientFormEs as Record<string, unknown>,
  fr: clientFormFr as Record<string, unknown>,
  fi: clientFormFi as Record<string, unknown>,
  tr: clientFormTr as Record<string, unknown>,
};

// Bundle loading: one request per language instead of per namespace (reduces fetches and works with CDN)
const bundleLoadedLangs: Record<string, boolean> = {};
const bundlePromiseByLang: Record<string, Promise<Record<string, Record<string, unknown>>>> = {};

function getFallbackForNamespace(namespace: string, language: string): Record<string, unknown> | null {
  const lang = language.split('-')[0].toLowerCase();
  const fallbackMap: Record<string, Record<string, Record<string, unknown>>> = {
    register: registerFallbacks,
    downloads: downloadsFallbacks,
    sidebar: sidebarFallbacks,
    onboarding: onboardingFallbacks,
    invitations: invitationsFallbacks,
    usages: usagesFallbacks,
    licenses: licensesFallbacks,
    acceptInvite: acceptInviteFallbacks,
    platformDefaults: platformDefaultsFallbacks,
    assets: assetsFallbacks,
    folders: foldersFallbacks,
    users: usersFallbacks,
    devices: devicesFallbacks,
    adminPasswords: adminPasswordsFallbacks,
    adminPolicy: adminPolicyFallbacks,
    adminNotifications: adminNotificationsFallbacks,
    adminWatermarks: adminWatermarksFallbacks,
    companies: companiesFallbacks,
    userDetails: userDetailsFallbacks,
    assetEdit: assetEditFallbacks,
    adminAssetProtection: adminAssetProtectionFallbacks,
    profile: profileFallbacks,
    settings: settingsFallbacks,
    subscriptions: subscriptionsFallbacks,
    inviteDetails: inviteDetailsFallbacks,
    clientForm: clientFormFallbacks,
  };
  const fallbacks = fallbackMap[namespace];
  if (!fallbacks) return null;
  const fb = fallbacks[lang] ?? fallbacks.en;
  return fb ?? null;
}

// Per-namespace URL pattern: backend builds /api/v1/translations/{{lng}}/{{ns}}?channel=web
const TRANSLATIONS_NS_REGEX = /^\/api\/v1\/translations\/([^/]+)\/([^/]+)(\?|$)/;

const MSGPACK_CONTENT_TYPE = 'application/x-msgpack';

/** Parse translation API response: MessagePack if Content-Type matches, else JSON. */
async function parseTranslationResponse(response: Response): Promise<unknown> {
  const ct = response.headers.get('Content-Type') ?? '';
  if (ct.startsWith(MSGPACK_CONTENT_TYPE)) {
    const ab = await response.arrayBuffer();
    return msgpackDecode(new Uint8Array(ab));
  }
  return response.json();
}

/** Build a translation API path with exactly one channel param (avoids ?channel=web?channel=web). */
function translationApiPath(pathname: string, channel = 'web', useMsgpack = false): string {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  const withoutQuery = path.split('?')[0];
  const base = `${withoutQuery}?channel=${encodeURIComponent(channel)}`;
  return useMsgpack ? `${base}&format=msgpack` : base;
}

function createTranslationRequest(
  bundleLoadedLangs: Record<string, boolean>,
  bundlePromiseByLang: Record<string, Promise<unknown>>,
): (options: Record<string, unknown>, url: string, payload: unknown, callback: (err: Error | null, res?: { status: number; data: string }) => void) => void {
  return (options, url, payload, callback) => {
    if (typeof payload === 'function') {
      callback = payload as (err: Error | null, res?: { status: number; data: string }) => void;
      payload = undefined;
    }
    callback = callback || (() => {});

    const match = !payload && typeof url === 'string' && url.match(TRANSLATIONS_NS_REGEX);
    if (!match) {
      // Not a GET for a single namespace (e.g. addPath POST): use default fetch
      // Normalize translation URLs to avoid duplicate ?channel=web (e.g. from backend queryStringParams)
      const fetchUrl =
        typeof url === 'string' && url.includes('/api/v1/translations/')
          ? translationApiPath(url)
          : url;
      const ro = options.requestOptions;
      const fetchOptions: RequestInit = {
        method: payload ? 'POST' : 'GET',
        body: payload ? (options.stringify as (p: unknown) => string)?.(payload) : undefined,
        credentials: 'include',
        ...(ro && typeof ro === 'object' && !Array.isArray(ro) ? ro as RequestInit : {}),
      };
      if (payload) (fetchOptions as Record<string, unknown>).headers = { 'Content-Type': 'application/json' };
      fetch(fetchUrl, fetchOptions)
        .then((res) => {
          if (!res.ok) return callback(new Error(res.statusText) as Error, { status: res.status, data: '' });
          return res.text().then((data) => callback(null, { status: res.status, data }));
        })
        .catch((e) => callback(e as Error));
      return;
    }

    const lng = (match[1] as string).split('-')[0].toLowerCase();
    const namespace = match[2] as string;

    (async () => {
      try {
        if (bundleLoadedLangs[lng]) {
          const data = i18n.getResourceBundle(lng, namespace) ?? {};
          callback(null, { status: 200, data: JSON.stringify(data) });
          return;
        }
        if (!bundlePromiseByLang[lng]) {
          bundlePromiseByLang[lng] = fetch(translationApiPath(`/api/v1/translations/${lng}/bundle`, 'web', true), {
            credentials: 'include',
            headers: { Accept: MSGPACK_CONTENT_TYPE },
          }).then((res) => (res.ok ? parseTranslationResponse(res) : Promise.reject(new Error(String(res.status)))));
        }
        const bundle = (await bundlePromiseByLang[lng]) as Record<string, Record<string, unknown>>;
        if (!bundleLoadedLangs[lng]) {
          for (const [ns, data] of Object.entries(bundle)) {
            if (data && typeof data === 'object') i18n.addResourceBundle(lng, ns, data, true, true);
          }
          bundleLoadedLangs[lng] = true;
        }
        const data = bundle[namespace] ?? {};
        callback(null, { status: 200, data: JSON.stringify(data) });
      } catch (_) {
        delete bundlePromiseByLang[lng];
        try {
          const response = await fetch(translationApiPath(`/api/v1/translations/${lng}/${namespace}`, 'web', true), {
            credentials: 'include',
            headers: { Accept: MSGPACK_CONTENT_TYPE },
          });
          if (response.ok) {
            const data = await parseTranslationResponse(response);
            callback(null, { status: 200, data: JSON.stringify(data) });
          } else if (response.status === 404) {
            const fallback = getFallbackForNamespace(namespace, lng);
            callback(null, { status: 200, data: JSON.stringify(fallback ?? {}) });
          } else {
            callback(new Error(String(response.status)) as Error, { status: response.status, data: '' });
          }
        } catch (err) {
          const fallback = getFallbackForNamespace(namespace, lng);
          callback(null, { status: 200, data: JSON.stringify(fallback ?? {}) });
        }
      }
    })();
  };
}

i18n
  .use(Backend) // Load translations from backend API
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    // Backend uses request() for every namespace; we override request to serve from bundle (one fetch per language)
    backend: {
      loadPath: '/api/v1/translations/{{lng}}/{{ns}}?channel=web',
      cache: true,
      requestOptions: {
        credentials: 'include',
      },
      request: createTranslationRequest(bundleLoadedLangs, bundlePromiseByLang),
    },
    
    // Start with empty resources - all translations loaded from database
    resources: {},
    
    // When a key is missing in current language, use English (bundled EN is seeded below so this works)
    fallbackLng: 'en',
    load: 'currentOnly',
    // If a key is still missing after fallback, return key (never undefined) to avoid parsing/display issues
    parseMissingKeyHandler: (key: string) => key,
    defaultNS: 'common', // Default namespace
    ns: ['common', 'login', 'register', 'forgotPassword', 'dashboard', 'sidebar', 'downloads', 'onboarding', 'invitations', 'usages', 'licenses', 'acceptInvite', 'platformDefaults', 'assets', 'folders', 'users', 'devices', 'adminPasswords', 'adminPolicy', 'adminNotifications', 'adminWatermarks', 'companies', 'clientForm', 'userDetails', 'assetEdit', 'adminAssetProtection', 'profile', 'settings', 'subscriptions', 'inviteDetails'], // Available namespaces
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      // Cookie only for language – survives logout and localStorage.clear(), readable anytime
      order: ['cookie', 'navigator', 'htmlTag'],
      lookupCookie: 'i18nextLng',
      caches: ['cookie'],
      cookieMinutes: 365 * 24 * 60, // 1 year
      cookieOptions: {
        path: '/',
        sameSite: 'lax',
      },
    },
    
    react: {
      useSuspense: false, // Disable suspense for now
    },
    
    // Ensure language changes don't cause page reloads
    // This is critical for preserving user state
    updateMissing: false,
    saveMissing: false,
    
    // Backend options
    partialBundledLanguages: true, // Allow partial translations
  });

// Seed English from bundled fallbacks so fallbackLng always has something to resolve (avoids missing-key issues)
const NAMESPACES_WITH_BUNDLED_FALLBACKS = [
  'register', 'downloads', 'sidebar', 'onboarding', 'invitations', 'usages', 'licenses', 'acceptInvite',
  'platformDefaults', 'assets', 'folders', 'users', 'devices', 'adminPasswords', 'adminPolicy', 'adminNotifications',
  'adminWatermarks', 'companies', 'clientForm', 'userDetails', 'assetEdit', 'adminAssetProtection', 'profile', 'settings', 'subscriptions', 'inviteDetails',
];
NAMESPACES_WITH_BUNDLED_FALLBACKS.forEach((ns) => {
  const enBundle = getFallbackForNamespace(ns, 'en');
  if (enBundle) i18n.addResourceBundle('en', ns, enBundle, true, true);
});

// Normalize language code (e.g., 'tr-TR' -> 'tr', 'fi-FI' -> 'fi')
const normalizeLanguageCode = (lng: string): string => {
  const baseLang = lng.split('-')[0].toLowerCase();
  const supportedLanguages = ['en', 'de', 'fr', 'es', 'tr', 'fi'];
  if (supportedLanguages.includes(baseLang)) {
    return baseLang;
  }
  return 'en'; // Fallback to English if not supported
};

// Listen for language changes and persist to cookie only (survives logout and localStorage.clear())
let isNormalizing = false;
i18n.on('languageChanged', (lng: string) => {
  try {
    // Normalize language code (e.g., 'tr-TR' -> 'tr')
    const normalizedLang = normalizeLanguageCode(lng);
    
    // If the language was normalized and we're not already normalizing, update i18n
    if (normalizedLang !== lng && !isNormalizing) {
      isNormalizing = true;
      i18n.changeLanguage(normalizedLang).then(() => {
        isNormalizing = false;
      });
      return; // Will trigger this event again with normalized code
    }
    
    // Persist to cookie only (survives logout and localStorage.clear())
    const expires = new Date();
    expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000); // 1 year
    document.cookie = `i18nextLng=${normalizedLang};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  } catch (e) {
    console.warn('Failed to save language to cookie:', e);
  }
});

export default i18n;
